import { useLazyQuery } from '@apollo/client';
import { Chip, TableColumnType, TableOrderByType } from '@elipssolution/harfang';
import { useCallback } from 'react';

import LinkIcon from '../../../../components/LinkIcon';
import SettingsTable from '../../../../components/SettingsTable';
import { DomainType } from '../../../../types/domain';
import { FETCH_DOMAINS, FetchDomainsType } from '../../../api/domain';

const columns: TableColumnType<DomainType>[] = [
	{
		field: 'name',
		key: 'name',
		sortable: true,
		title: 'Nom du domaine',
		width: 200,
	},
	{
		key: 'chip',
		flexGrow: 0,
		render: ({ isDefault }) => isDefault && <Chip label="Défaut" color="info" />,
		width: 165,
	},
	{
		flexGrow: 0,
		key: 'navigate',
		render: () => <LinkIcon />,
		width: 24,
	},
];

type DomainsTableSectionProps = {
	onDomainSelection?: (domain: DomainType) => void;
};

const DomainsTableSection = ({ onDomainSelection }: DomainsTableSectionProps) => {
	const [fetchDomains] = useLazyQuery<FetchDomainsType>(FETCH_DOMAINS);

	const dataSource = useCallback(
		async (
			limit: number,
			offset: number,
			search?: string,
			orderBy?: TableOrderByType<DomainType>,
		): Promise<{
			count: number;
			items: DomainType[];
		}> => {
			const { field, order } = orderBy || {};

			const { data, error } = await fetchDomains({
				variables: {
					...(orderBy && { orderBy: { field, order } }),
					page: {
						limit,
						offset,
					},
					search,
				},
			});

			if (error) {
				throw error;
			}

			const {
				domains: { count = 0, items = [] },
			} = data ?? {
				domains: {},
			};

			return {
				count,
				items,
			};
		},
		[fetchDomains],
	);

	const handleDomainSelection = useCallback((domain: DomainType) => onDomainSelection?.(domain), [onDomainSelection]);

	return (
		<SettingsTable dataSource={dataSource} onRowClick={handleDomainSelection} tableColumns={columns} title="Domaines" />
	);
};

export default DomainsTableSection;
